import React, { useState } from 'react';
import { Button, Icon, Link } from 'framework7-react';
import PropTypes from 'prop-types';
import II18 from '../translate/II18';
import { getIcon } from '../helpers/utils';
import { isAppOnline } from '../../lib/utils';

/**
 * Desktop standalone FAB that morphs into a paste-URL bar.
 *
 * @param {{ onSubmit: (url: string) => void }} props
 * @returns {JSX.Element}
 */
export default function DesktopStartRequestFab({ onSubmit }) {
  const [open, setOpen] = useState(false);
  const [url, setUrl] = useState('');

  const openPaste = () => {
    if (!isAppOnline()) return;
    setUrl('');
    setOpen(true);
  };

  const closePaste = () => {
    setUrl('');
    setOpen(false);
  };

  const submit = () => {
    const value = (url || '').trim();
    if (!value) return;
    onSubmit(value);
    setUrl('');
    setOpen(false);
  };

  return (
    <div className={'start-qr-url-fab' + (open ? ' open' : '')}>
      {!open ? (
        <button
          type="button"
          className="start-qr-url-fab__trigger"
          id="startRequestFab"
          onClick={openPaste}
        >
          <Icon material="play_arrow" />
          <span>{II18.get('qr_start_request_btn')}</span>
        </button>
      ) : (
        <div className="start-qr-url-fab__paste">
          <input
            id="pasteRequestUrl"
            type="text"
            autoFocus
            value={url}
            placeholder={II18.get('qr_paste_url_placeholder')}
            onChange={e => setUrl(e.target.value)}
            onKeyDown={e => {
              if (e.key === 'Enter') {
                e.preventDefault();
                submit();
              }
              if (e.key === 'Escape') {
                e.preventDefault();
                closePaste();
              }
            }}
          />
          <Button
            id="btnStartRequestFromUrl"
            className="scan-portal"
            fill
            onClick={submit}
          >
            {getIcon('material:chevron_right', 20)}
          </Button>
          <Link
            id="closeUrlPaste"
            className="start-qr-url-fab__close"
            onClick={closePaste}
          >
            <Icon material="close" />
          </Link>
        </div>
      )}
    </div>
  );
}

DesktopStartRequestFab.propTypes = {
  onSubmit: PropTypes.func.isRequired
};
